import { createFileRoute } from "@tanstack/react-router";
import { ShelvesPage } from "@/components/shelves/shelves-page";
import { shelvesQuery } from "@/lib/shelves";

export const Route = createFileRoute("/_app/shelves/")({
  loader: ({ context }) => context.queryClient.prefetchQuery(shelvesQuery),
  component: ShelvesPage,
});
